import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useCallback, useState } from "react";
import { CSVLink } from "react-csv";
import { debounce } from "../../../../../utils";
import "../../../../Admin/Reports/Reports Detailed/ReportsDetailed.css";
import { BreadcrumbAdmin } from "../../../../UI/BreadcrumbAdmin";
import DateRangePickerComp from "../../../../UI/DateRangePicker";
import { Search } from "../../../../UI/Search/Search";
import { UserStatisticTable } from "./UserStatisticTable";
import { useOutsideClick } from "../../../../../hooks/useOutsideClick";

const list = [
  {
    name: "depName",
    label: "Company Name",
  },
  { name: "hod", label: "Company Admin" },
  { name: "totalUsers", label: "Total user" },
  { name: "activeUsers", label: "Active" },
  { name: "inactiveUsers", label: "Inactive" },
  { name: "depPoints", label: "Total Company Points" },
];

const padDateUnit = (value) => String(value).padStart(2, "0");

const toIsoDatePart = (date) => {
  const selectedDate = new Date(date);
  const year = selectedDate.getFullYear();
  const month = padDateUnit(selectedDate.getMonth() + 1);
  const day = padDateUnit(selectedDate.getDate());
  return `${year}-${month}-${day}`;
};

const toUtcDayStartISOString = (date) => `${toIsoDatePart(date)}T00:00:00.000Z`;

const toUtcDayEndISOString = (date) => `${toIsoDatePart(date)}T23:59:59.999Z`;

export const UserStatistic = () => {
  const [select, setSelect] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const ref = React.useRef(null);

  const closePopup = () => {
  setSelect(false);
  };

  useOutsideClick(ref, closePopup);

  const [dateRange, setDateRange] = React.useState(null);
  const [check, setCheck] = useState({
    depName: true,
    hod: true,
    totalUsers: true,
    activeUsers: true,
    inactiveUsers: true,
    depPoints: true,
  });
  const [csvData, setCsvData] = useState([]);

  const base = [
    {
      _id: 1,
      link: "/super-admin/reports",
      label: "Reports",
    },
  ];

  const setDebouncedSearchQuery = useCallback(
    debounce((value) => {
      setSearchQuery(value);
    }, 500),
    []
  );

  const handleChange = (e) => {
    setCheck({ ...check, [e.target.name]: e.target.checked });
  };

  return (
    <div className="container">
      <BreadcrumbAdmin
        base={base}
        page={'Organizational User Statistics'}
      />
      <div className="reportsDetailed__head">
        <Search
          mini
          setSearchVal={(val) => setDebouncedSearchQuery(val)}
          placehold={'Search by company, admin name, email...'}
        />
        <div className="reportsDetailed__headright">
          <DateRangePickerComp
            onChange={(value) => {
              if (!value) {
                setDateRange(null);
              } else {
                const [start, end] = value;
                if (!start || !end) {
                  setDateRange(null);
                  return;
                }
                setDateRange([
                  toUtcDayStartISOString(start),
                  toUtcDayEndISOString(end),
                ]);
              }
            }}
          />
          <div ref={ref} className="reports__selectLayout">
            <Button
              variant="outlined"
              endIcon={
                <ArrowForwardIosIcon
                  sx={{
                    transform: select ? 'rotate(-90deg)' : 'rotate(90deg)',
                    color: 'grey',
                    fontSize: '16px !important',
                  }}
                />
              }
              sx={{
                color: 'var(--grey400)',
                borderColor: 'var(--grey300)',
                width: '150px',
                fontWeight: '400 !important',
              }}
              onClick={() => setSelect(!select)}>
              Manage Field
            </Button>
            <div
              className={select ? 'reports__selectActive' : 'reports__select'}>
              <div className="reports__selectcontent">
                {list.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        defaultChecked={item.name}
                        name={item.name}
                        onChange={handleChange}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: '20px' } }}
                      />
                    }
                    onChange={handleChange}
                    label={
                      <span style={{ fontSize: '15px' }}>{item.label}</span>
                    }
                  />
                ))}
              </div>
            </div>
          </div>
          <CSVLink
            filename="User statistics"
            data={csvData}>
            <Button
              variant="contained"
              endIcon={<FileUploadOutlinedIcon sx={{ color: 'white' }} />}>
              Export
            </Button>
          </CSVLink>
        </div>
      </div>

      <div className="reports__table">
        <UserStatisticTable
          check={check}
          searchQuery={searchQuery}
          startDate={dateRange && dateRange[0]}
          endDate={dateRange && dateRange[1]}
          getTableData={(data) => {
            let cleanedCSVData = data?.data?.map((obj) => {
              let d = {
                'Company name': obj.name,
                'Company Admin':
                  obj.companyAdmin?.fname && obj.companyAdmin?.lname
                    ? `${obj.companyAdmin?.fname} ${obj.companyAdmin?.lname}`
                    : obj.companyAdmin?.email,
                'Total users': obj.totalUsers,
                Active: obj.totalActiveUsers,
                Inactive: obj.totalInActiveUsers,
                'Total company points': obj.totalCompanyPoints,
              };
              return d;
            });
            setCsvData(cleanedCSVData);
          }}
        />
      </div>
    </div>
  );
};
